import { render, staticRenderFns } from "./BindsDialogConfirm.vue?vue&type=template&id=1288d176&"
import script from "./BindsDialogConfirm.vue?vue&type=script&lang=js&"
export * from "./BindsDialogConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports